import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchAansluitingValuelists,
  initialState,
} from '../services/fetchAansluitingValuelists'

export { useAansluitingValuelists, queryKey }

const queryKey = 'valuelists-aansluiting'

const useAansluitingValuelists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchAansluitingValuelists,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
